import { render } from "./PaymentConfig.vue?vue&type=template&id=2345f4a4"
import script from "./PaymentConfig.vue?vue&type=script&lang=js"
export * from "./PaymentConfig.vue?vue&type=script&lang=js"

import "./PaymentConfig.vue?vue&type=style&index=0&id=2345f4a4&lang=css"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__